// Add links to category buttons
document.addEventListener('DOMContentLoaded', function() {
  // Button ID to URL mapping
  const buttonLinks = {
    'glXQ2TiYQH': 'https://www.pattisue.shop/collections/tops',                      // Womans Tops
    'gS3m9TBOTD': 'https://www.pattisue.shop/collections/curvy-tops',                // Curvy Tops
    'gLDdlSLwjf': 'https://www.pattisue.shop/collections/bottoms',                   // Women's Bottoms
    'gbLJ4hmsMG': 'https://www.pattisue.shop/collections/curvy-bottoms',             // Curvy Bottoms
    'gPittFinalCall': 'https://www.pattisue.shop/collections/last-chance-boutique-finds'  // Patti's Final Call
  };

  // Add click handlers to buttons
  Object.keys(buttonLinks).forEach(function(buttonId) {
    const button = document.querySelector('[data-id="' + buttonId + '"]');
    if (button) {
      button.style.cursor = 'pointer';
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = buttonLinks[buttonId];
      });
    }
  });
});
